import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

// Сколько компаний показывать в подсказке; остальные считаются строкой «и ещё N».
const SHOWN = 20;

const useStyles = makeStyles((theme) => ({
  count: {
    cursor: 'help',
    borderBottom: '1px dotted currentColor',
  },
  tooltip: {
    maxWidth: 360,
    padding: theme.spacing(1),
    fontSize: 13,
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  link: {
    color: 'inherit',
    fontWeight: 600,
    textDecoration: 'underline',
  },
  phone: {
    opacity: 0.8,
  },
}));

// «У 1 компании», «У 2 компаний», «У 21 компании».
const companiesWord = (count) => (count % 10 === 1 && count % 100 !== 11 ? 'компании' : 'компаний');

// Предупреждение над базой контактов: у каких компаний нет номера для WhatsApp. Число — это
// подсказка: при наведении видны названия, каждое ведёт на страницу компании, где номер
// можно исправить («Редактировать»).
function WithoutPhoneHint({ companies }) {
  const classes = useStyles();
  if (!companies || companies.length === 0) return null;

  const rest = companies.length - SHOWN;
  const title = (
    <ul className={classes.list}>
      {companies.slice(0, SHOWN).map((company) => (
        <li key={company.id}>
          <Link to={`/companypage?id=${company.id}`} className={classes.link}>
            {company.name || `Компания ${company.id}`}
          </Link>{' '}
          <span className={classes.phone}>
            {company.phone ? `— номер в карточке: ${company.phone}` : '— номер не указан'}
          </span>
        </li>
      ))}
      {rest > 0 && <li>{`и ещё ${rest}`}</li>}
    </ul>
  );

  return (
    <>
      {'У '}
      <Tooltip title={title} interactive enterDelay={0} leaveDelay={250} classes={{ tooltip: classes.tooltip }}>
        <span className={classes.count}>{companies.length}</span>
      </Tooltip>
      {` ${companiesWord(companies.length)} нет номера вида +380XXXXXXXXX: в рассылку они не попадут. Исправить номер можно на странице компании: наведите на число и выберите компанию.`}
    </>
  );
}

export default WithoutPhoneHint;
